import React, { useState, useEffect } from "react";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormSelectStyle4 from "../../UIElements/FormSelect";
import FormButtonStyle4 from "../../UIElements/FormButton";
import { setUserClickData } from "../../../../utility/setUserClickData";
import ImageRadioButton from "../../UIElements/ImageRadioButtons";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllianceLeadFromMoneyTapInput } from "../../../../utility/commonUtils";
import callApi from "../../../../utility/apiCaller";
import { useSelector } from "react-redux";

const options = [
  {
    label: "Owned",
    value: "owned",
    selectedImage: "/images/selected.png",
    unselectedImage: "/images/unselected.png",
  },
  {
    label: "Rented",
    value: "rented",
    selectedImage: "/images/selected.png",
    unselectedImage: "/images/unselected.png",
  },
];

function ProfessionalInformationForm({
  formData,
  setFormData,
  setCurrentStep,
}) {
  const [company_name, setcompany_name] = useState("");
  const [company_type, setcompany_type] = useState("");
  const [work_email, setEmail] = useState("");
  const [monthly_income, setIncome] = useState("");
  const [loan_purpose, setloan_purpose] = useState(null);
  const [ownership, setOwnership] = useState(null);

  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const leadFromStore = useSelector((state) => state?.app?.lead);
  console.log(leadFromStore);
  const leadId = leadFromStore?.id;
  const user = useSelector((state) => state.app.user);

  const [searchParams] = useSearchParams();
  const lid = searchParams.get("lid");
  const utm_source = searchParams.get("utm_source");
  const utm_medium = searchParams.get("utm_medium");
  const aff_id = searchParams.get("aff_id");

  // ✅ Live validation for only active fields
  useEffect(() => {
    const allValid =
      company_name.trim() &&
      company_type &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(work_email) &&
      monthly_income &&
      loan_purpose &&
      (formData?.professionType === "self_employed" ? ownership : true);

    setIsFormValid(allValid);
  }, [
    company_name,
    company_type,
    work_email,
    monthly_income,
    loan_purpose,
    ownership,
    formData?.professionType,
  ]);

  // ✅ Validation handler
  const handleValidation = () => {
    const newErrors = {};
    if (!company_name.trim()) newErrors.company_name = true;
    if (!company_type) newErrors.company_type = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(work_email))
      newErrors.work_email = true;
    if (!monthly_income) newErrors.monthly_income = true;
    if (!loan_purpose) newErrors.loan_purpose = true;
    if (formData?.professionType === "self_employed" && !ownership)
      newErrors.ownership = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    if (!handleValidation()) return;

    setUserClickData({
      event_name: "professional-details-form-submit-for-fb-campaign",
      utm_source: utm_source,
      user_id: formData.mobile || "No User ID found here",
      affiliate_id: searchParams.get("aff_id") || "No Aff_id found",
    });

    setFormData({
      ...formData,
      company_name,
      company_type,
      work_email,
      monthly_income: Number(monthly_income.replace(/,/g, "")),
      loan_purpose,
      ownership,
    });

    try {
      // API call to save/update lead
      const res = await callApi(
        `v1/lead/${leadId}/update-lead-new`,
        "post",
        {
          lead: {
            company_name,
            company_type,
            work_email,
            monthly_income: Number(monthly_income.replace(/,/g, "")),
            loan_purpose,
            ownership,
            steps_completed: 3,
          },
        },
        "core",
        user?.token || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..."
      );

      if (res?.status === "Success") {
        toast.success("Form data updated successfully");

        // Step 5: Move to next step ONLY on successful API response
        setCurrentStep((prev) => prev + 1);
      } else {
        toast.error(res?.message || "Failed to update form data");
      }
    } catch (error) {
      console.error("Error updating lead:", error);
      toast.error("Something went wrong while updating form data");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="font-polysans -mt-5">
      {/* Title */}
      <div className="flex items-center gap-3 w-full px-2.5">
        <div className="w-10 border-t border-gray-300"></div>
        <h1 className="text-[clamp(1rem,5vw,20px)] font-atkinson-bold">
          Professional information
        </h1>
        <div className="w-10 border-t border-gray-300"></div>
      </div>
      <p className="text-center text-[12px] font-atkinson mb-3 text-[#818181]">
        You’re just a One step away from your ideal loan!
      </p>

      {/* Inputs */}
      <FormInputStyle4
        label="Company Name"
        value={company_name}
        onChange={(e) => setcompany_name(e.target.value)}
        isValid={!errors.company_name}
        errorMessage="Company name is required"
      />

      <FormSelectStyle4
        label="Company Type"
        value={company_type}
        onChange={setcompany_type}
        options={[
          { label: "Private Limited Company (Pvt Ltd)", value: "private" },
          { label: "Public Limited Company", value: "public" },
          { label: "Partnership", value: "partnership" },
          { label: "Proprietorship", value: "proprietorship" },
        ]}
        isValid={!errors.company_type}
        errorMessage="Please select company type"
      />

      <FormInputStyle4
        label="Work email Address"
        value={work_email}
        onChange={(e) => setEmail(e.target.value)}
        isValid={!errors.work_email}
        errorMessage="Enter a valid work email"
      />

      <FormInputStyle4
        label="Monthly income"
        value={monthly_income}
        onChange={(e) => {
          const rawValue = e.target.value.replace(/\D/g, "");
          console.log(rawValue);
          if (rawValue) {
            setIncome(Number(rawValue).toLocaleString("en-IN"));
          } else {
            setIncome("");
          }
          if (errors.monthly_income) {
            setErrors((prev) => ({ ...prev, monthly_income: false }));
          }
        }}
        onBlur={() => {
          if (monthly_income) {
            const rawValue = monthly_income.replace(/\D/g, "");
            setIncome(Number(rawValue).toLocaleString("en-IN"));
          }
        }}
        isValid={!errors.monthly_income}
        errorMessage="Enter monthly income"
      />

      <FormSelectStyle4
        label="Purpose of Loan"
        value={loan_purpose}
        onChange={setloan_purpose}
               options={[
          { label: "Wedding/Other Events", value: "wedding/other events" },
          { label: "Medical Expenses", value: "medical expenses" },
          { label: "Home Renovation", value: "home renovation" },
          { label: "Travel Expenses", value: "travel expenses" },
          { label: "Education Expenses", value: "education expenses" },
          { label: "Business Expenses", value: "business expenses" },
          { label: "Electronics Purchase", value: "electronics purchase" },
          { label: "Jewellery Purchase", value: "jewellery purchase" },
          {
            label: "Stock Market Trading/Investment",
            value: "stock market trading/investment",
          },
          {
            label: "Betting/Gambling/Speculative purposes",
            value: "betting/gambling/speculative purposes",
          },
          { label: "Other Personal Use", value: "other personal use" },
        ]}
        isValid={!errors.loan_purpose}
        errorMessage="Please select purpose"
      />

      {formData?.professionType === "self_employed" && (
        <div className="p-2 w-[80%] mx-auto">
          <p className="mb-2 font-atkinson text-[#1B1B1B] text-[14px]">
            Business ownership type
          </p>
          <ImageRadioButton
            options={options}
            name="businessOwnership"
            selectedValue={ownership}
            onChange={setOwnership}
          />
          {errors.ownership && (
            <p className="text-red-500 text-xs mt-1">
              Please select ownership type
            </p>
          )}
        </div>
      )}

      {/* Submit */}
      <FormButtonStyle4
        className="mt-4 mb-6"
        text="Get My Offers"
        disabled={!isFormValid}
        isLoading={isLoading}
        onClick={handleSubmit}
        id="btn-professional-page-landing-v9"
      />
    </div>
  );
}

export default ProfessionalInformationForm;
